import { TextAndIconButton } from 'src/components/atomsLegacy';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const StyledDialog = styled.dialog<{
  show?: boolean;
  screenWidth: number;
}>`
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  width: ${(props) =>
    props.screenWidth < 444 ? `${props.screenWidth}px` : '444px'};
  min-height: 200px;
  flex: 1 1 auto;
  background-color: white;
  border-radius: 4px;
  box-shadow:
    0px 11px 15px -7px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 14%),
    0px 9px 46px 8px rgb(0 0 0 / 12%);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: none;
  height: min-content;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 20px;
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-family: ${theme.typography.fontFamily}; font-weight: 400;`
      : textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${({ theme }) =>
    theme.isVaultVariant ? 'inherit' : theme.atlas.semantic.color.type.default};
  margin: 0px;
`;

export const Body = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-size: 1rem; font-family: ${theme.typography.fontFamily}; font-weight: 400; line-height: 1.5; color: rgba(0, 0, 0, 0.54);`
      : textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? 'rgba(0, 0, 0, 0.54)'
      : theme.atlas.semantic.color.type.muted};
  margin: 24px 0px;
  align-self: stretch;
  white-space: normal;
  overflow-wrap: break-word;
`;

export const ButtonContainer = styled.div`
  display: flex;
  column-gap: 16px;
`;

export const CancelButton = styled(TextAndIconButton)`
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N200
      : props.theme.atlas.semantic.color.surface.default};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N1000
      : props.theme.atlas.semantic.color.type.default};
  padding: 7px 16px;
  gap: 8px;
  border: solid 1px
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N500
        : props.theme.atlas.semantic.color.ui.divider.default};
  min-width: 70px;
  display: flex;
  justify-content: center;
`;

export const ConfirmButton = styled(TextAndIconButton)`
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
  padding: 7px 16px;
  gap: 8px;
  min-width: 70px;
  display: flex;
  justify-content: center;
`;
